import { render } from "./VariantForm.vue?vue&type=template&id=99ee933a"
import script from "./VariantForm.vue?vue&type=script&lang=js"
export * from "./VariantForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__